import { createSelector } from 'reselect';
import PredesComplianceGapsInDespatchNumbersColumns from '../../containers/PredesComplianceGapsInDespatchNumbersColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.PREDES_COMPLIANCE_GAPS_IN_DESPATCH_NUMBERS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.PREDES_COMPLIANCE_GAPS_IN_DESPATCH_NUMBERS.isLoading;

export const getData =
  ReportDefinitions.PREDES_COMPLIANCE_GAPS_IN_DESPATCH_NUMBERS.getDataFunction();

export const getColumns =
  createSelector(getData, PredesComplianceGapsInDespatchNumbersColumns);
